import { ToastType } from '../../services/toast-message.service';

export interface IToastProps {
  titleColor: string;
  boxShadow: string;
  icon: string;
}

export const TOAST_CONFIG: Record<ToastType, IToastProps> = {
  [ToastType.SUCCESS]: {
    titleColor: 'text-[#17B26A]',
    boxShadow: '0 0 150px 5px #00df80, 0 0 100px #00df80, 0 0 50px #00df8080',
    icon: 'icon-toast-success',
  },
  [ToastType.ERROR]: {
    titleColor: 'text-[#F04438]',
    boxShadow: '0 0 100px 5px #f04349, 0 0 100px #f04349, 0 0 50px #f0434980',
    icon: 'icon-toast-error',
  },
  [ToastType.INFO]: {
    titleColor: 'text-[#5ACDFF]',
    boxShadow: '0 0 150px 5px #00B2FF, 0 0 100px #00B2FF, 0 0 50px #00B2FF80',
    icon: 'icon-toast-info',
  },
  [ToastType.WARNING]: {
    titleColor: 'text-[#FDB022]',
    boxShadow: '0 0 100px 5px #FFB800, 0 0 100px #FFB800, 0 0 50px #FFB80080',
    icon: 'icon-toast-warning',
  },
};
